import { faGlobe, faHeadphones, faLeaf, faMapMarkerAlt, faSheetPlastic, faWrench } from "@fortawesome/free-solid-svg-icons";

const headings = {
    page1: {
        heading1:"No borders, no limits. ",
        heading2:"Our global recruitment strategy ensures you find the best talent, wherever it’s needed.",
        para1:" See how our global employment solutions can support your business in managing workforce needs and scaling your operations across borders.",
        para2:"Set up a personalized consultation with a global growth specialist to discuss how we can support your international success",
    },
    page2 : {
        heading1:"How Ampstekpay Simplifies",
        heading2:" Contingent Workforce Management",
        para1:" Hiring and managing contingent workers involves navigating complex regulations in different countries. With Ampstekpay, we handle all aspects of workforce engagement so you can focus on growing your business. Our solution offers:",
        para2:""
    },
    page3: {
        heading1:"Why Choose Ampstekpay? ",
        heading2:"",
        para1:" For over two decades, Ampstekpay has been empowering recruitment agencies to manage contractors across the globe. Trusted by leading staffing and recruitment agencies, ",
        para2:"we offer flexible, scalable, and compliant solutions tailored to meet the unique needs of major markets worldwide. With our deep expertise and commitment to excellence, Ampstekpay simplifies global hiring, allowing you to focus on growing your business while we handle the complexities of international workforce management.",
    },
    page4 : {
        heading1:"Why Ampstekpay is the Ideal Solution for ",
        heading2:"Contractor Compliance and Management",
        para1:" Ampstekpay is your trusted partner for managing independent contractors globally. Our Employer of Record (EOR) services handle all the complexities of contractor management, including compliance, payroll, onboarding, and offboarding, across multiple regions. By choosing Ampstekpay, you can streamline contractor management, mitigate compliance risks, and ensure timely payments, all without needing to set up local entities. Let us simplify the process so your recruitment agency can focus on sourcing talent and driving business growth with confidence",
        para2:""
    }
}

const homeservices = [
        {          
          title: "Global Employer of Record",
          description:
            "We simplify global employment, allowing you to hire anyone, anywhere. From payroll and benefits management to contracts that comply with tax and labor laws, we handle it all—so you don’t have to.",
         iconClass: faMapMarkerAlt,
         url:'/companies-hiring-internationally/global-employer-of-record',
        },
        {
          title: "Independent Contractors",
          description:
            "Looking to hire for short-term projects? Easily engage and pay independent contractors worldwide, all while staying fully compliant with local regulations.",
          iconClass: faHeadphones ,
           url:'/staffing-and-recruitment-firms/independent-contractor-management/',
        }
    ];
const staffingservices = [
    {          
        title: "Global Employer of Record",
        description:
        "We simplify global employment, allowing you to hire anyone, anywhere. From payroll and benefits management to contracts that comply with tax and labor laws, we handle it all—so you don’t have to.",
        iconClass: faMapMarkerAlt,
        url:'/staffing-and-recruitment-firms/employer-of-record-for-recruitment-firms/',
    },
    {
        title: "Independent Contractors",
        description:
        "Looking to hire for short-term projects? Easily engage and pay independent contractors worldwide, all while staying fully compliant with local regulations.",
        iconClass: faHeadphones ,
        url:'/staffing-and-recruitment-firms/independent-contractor-management/',
    }
];
const companyservices = [
    {
        title: "Global Employer of Record",
        description:
        "We simplify global employment, allowing you to hire anyone, anywhere. From payroll and benefits management to contracts that comply with tax and labor laws, we handle it all—so you don’t have to.",
        iconClass: faMapMarkerAlt,
        url:'/companies-hiring-internationally/global-employer-of-record',
    },
    {
        title: "Contingent Workforce Management",
        description:
        "Looking to hire for short-term projects? Easily engage and pay independent contractors worldwide, all while staying fully compliant with local regulations.",
        iconClass: faHeadphones ,
        url:'/companies-hiring-internationally/contingent-workforce-management',
    }
];
const EORservices = [
    {
        title: "Local Expertise, Global Reach",
        description:
        "We cover 40+ countries with teams of specialists for each region. We handle the tricky local labour laws, tax regulations, and benefits management, ensuring your employees are taken care of wherever they are.",
        iconClass: faMapMarkerAlt,
        url:'/meet-the-experts',
    },
    {
        title: "Stress-Free Payroll",
        description:
        "Forget the headaches of multi-currency payments and compliance - we make sure everyone gets paid on time and in accordance with local laws.",
        iconClass: faHeadphones ,
        url:'/meet-the-experts',
    },
    {
        title: "Compliant Hiring",
        description:
        "We manage all your legal employment obligations - contracts, taxes, and benefits; all while minimising risk and keeping your business compliant.",
        iconClass: faGlobe,
        url:'/meet-the-experts',
    },
];
const contingent = [
    {
        title: "Local Expertise, Global Reach",
        description:
        "We cover 40+ countries with teams of specialists for each region. We handle the tricky local labour laws, tax regulations, and benefits management, ensuring your employees are taken care of wherever they are.",
        iconClass: faMapMarkerAlt,
        url:'/countries',
    },
    {
        title: "Stress-Free Payroll",
        description:
        "Forget the headaches of multi-currency payments and compliance - we make sure everyone gets paid on time and in accordance with local laws.",
        iconClass: faHeadphones ,
        url:'/countries'
    },
    {
        title: "Flexible and Scalable Solutions",
        description:
        "Our team supports your business needs whether you’re hiring one contractor or managing a global network of freelancers. Quickly onboard and offboard workers as per the needs of your business..",
        iconClass: faGlobe,
        url:'/countries'
    },
];
const StaffingEORservices = [
    {
        title: "Global Hiring Made Easy",
        description:
        "Ampstekpay simplifies contractor management by acting as the Employer of Record, ensuring compliance and handling payroll across multiple countries—no need for local entities.",
        iconClass: faMapMarkerAlt,
        url:'/meet-the-experts',
    },
    {
        title: "Effortless Global Expansion",
        description:
        "Expand your recruitment business worldwide with Ampstekpay. We manage compliance, payroll, and contractor onboarding, allowing you to focus on talent placement.",
        iconClass: faHeadphones ,
        url:'/meet-the-experts',
    },
    {
        title: "Seamless Workforce Solutions",
        description:
        "Ampstekpay handles all the legal, payroll, and compliance details, enabling you to place contractors in global markets without the complexity of setting up local entities.",
        iconClass: faGlobe,
        url:'/meet-the-experts',
    },
];

const StaffingIndependentdata = [
    {
        title: "Effortless Global Contractor Management",
        description:
        "Manage contractors globally with ease. Ampstekpay handles compliance, payroll, and onboarding, so you can focus on growing your business without local entity setup.",
        iconClass: faSheetPlastic,
        url:'/countries',
    },
    {
        title: "End-to-End Support",
        description:
        "Ampstekpay ensures contractor compliance worldwide. Streamline payroll, onboarding, and offboarding across 40+ countries without the complexity of managing local regulations",
        iconClass: faWrench ,
        url:'/countries'
    },
    {
        title: "Global Hiring Made Easy",
        description:
        "Ampstekpay simplifies global hiring by managing contractor employment, compliance, and payments, allowing you to expand your recruitment efforts seamlessly.",
        iconClass: faLeaf ,
        url:'/countries'
    },
];
export { headings, homeservices, companyservices , EORservices,contingent,StaffingEORservices,StaffingIndependentdata,staffingservices};